import { Card, Collapse, Stack, Tooltip, Typography } from "@mui/material";
import FieldLabel from "components/FieldLabel";
import SwitchControl from "components/form/SwitchControl";
import { useFormContext } from "react-hook-form";
import { palette } from "theme";
import { CandidateInputs } from "../../types";
import { AuthSetting } from "./types";

interface SettingsCardProps {
  isEditing: boolean;
  setting: AuthSetting;
}

const SettingCard = ({ isEditing, setting }: SettingsCardProps) => {
  const { Icon, tooltipProps } = setting;
  const { title: tooltipTitle, ...restTooltipProps } = tooltipProps || {};
  const { watch } = useFormContext<CandidateInputs>();

  const switchName = `authSettingsSwitch.${setting.name}` as const;
  const switchValue = watch(switchName);

  return (
    <Card
      variant='outlined'
      sx={{ p: 2 }}>
      <Stack
        direction='row'
        justifyContent='space-between'>
        <Stack
          direction='row'
          alignItems='center'
          spacing={1.5}>
          <Icon fontSize='large' />
          <Stack>
            <Typography
              variant='subtitle18rg'
              fontWeight={600}>
              {setting.title}
            </Typography>
            <FieldLabel label={setting.subtitle} />
          </Stack>
        </Stack>
        <Tooltip
          title={tooltipTitle}
          {...restTooltipProps}>
          <Stack>
            <SwitchControl
              name={switchName}
              formControlLabelProps={{ sx: { mr: 0 }, disabled: setting.disabled || !isEditing }}
            />
          </Stack>
        </Tooltip>
      </Stack>
      <Collapse
        in={switchValue}
        timeout='auto'
        unmountOnExit>
        <Stack
          spacing={2}
          sx={{ pt: 2, mt: 2, borderTop: `1px solid ${palette.divider}` }}>
          {setting.fields}
        </Stack>
      </Collapse>
    </Card>
  );
};

export default SettingCard;
